import React, { useContext, useState } from 'react';
import { HashRouter, MemoryRouter, Redirect, Route, Switch } from 'react-router-dom';
import {
    BASE_ROUTE,
    ERROR_ROUTE,
    ESTIMATES_ROUTE,
    SEARCH_ROUTE,
    SINGLE_ESTIMATE_ROUTE,
    LOGIN_ROUTE,
} from '../../../constants';
import { FormContext } from '../../../context/Form.context';
import FallbackPage from '../../Error/Fallback.component';
import { EstimatesPage, SingleEstimatesPage } from '../../estimates';
import MemberPage from '../../member/components/Member.page';
import SearchPage from '../../search/components/Search.page';

export default function EpeRouter(props) {
    const [provider, setProvider] = useState(0);
    const [loading, setLoading] = useState(false);
    const [currentSelectedServiceForDisplay, setCurrentSelectedServiceForDisplay] = useState('');
    const [open, setOpen] = useState(false);
    const [otherLocationsOpen, setOtherLocationsOpen] = useState(false);
    const [closestLocationIndex, setClosestLocationIndex] = useState([0]);
    const [topLocation, setTopLocation] = useState(0);
    const { haveMemberDetails } = useContext(FormContext);

    function getSwitch() {
        return (
            <Switch>
                <Route
                    path={BASE_ROUTE}
                    exact
                    render={() => {
                        return <Redirect to={LOGIN_ROUTE} />;
                    }}
                />
                <Route
                    path={LOGIN_ROUTE}
                    exact
                    render={() => {
                        return <MemberPage {...props} />;
                    }}
                />
                <Route
                    path={SEARCH_ROUTE}
                    exact
                    render={() => {
                        if (!haveMemberDetails()) {
                            return <Redirect to={LOGIN_ROUTE} />;
                        }
                        return (
                            <SearchPage
                                setProvider={setProvider}
                                loading={loading}
                                setLoading={setLoading}
                                currentSelectedServiceForDisplay={currentSelectedServiceForDisplay}
                                setCurrentSelectedServiceForDisplay={
                                    setCurrentSelectedServiceForDisplay
                                }
                                open={open}
                                setOpen={setOpen}
                            />
                        );
                    }}
                />
                <Route
                    path={ESTIMATES_ROUTE}
                    exact
                    render={() => {
                        if (!haveMemberDetails()) {
                            return <Redirect to={LOGIN_ROUTE} />;
                        }
                        return (
                            <EstimatesPage
                                setProvider={setProvider}
                                loading={loading}
                                setLoading={setLoading}
                                currentSelectedServiceForDisplay={currentSelectedServiceForDisplay}
                                setCurrentSelectedServiceForDisplay={
                                    setCurrentSelectedServiceForDisplay
                                }
                                otherLocationsOpen={otherLocationsOpen}
                                setOtherLocationsOpen={setOtherLocationsOpen}
                                closestLocationIndex={closestLocationIndex}
                                setClosestLocationIndex={setClosestLocationIndex}
                                topLocation={topLocation}
                                setTopLocation={setTopLocation}
                                provider={provider}
                            />
                        );
                    }}
                />
                <Route
                    path={SINGLE_ESTIMATE_ROUTE}
                    exact
                    render={() => {
                        if (!haveMemberDetails()) {
                            return <Redirect to={LOGIN_ROUTE} />;
                        }
                        return (
                            <SingleEstimatesPage
                                setCurrentSelectedServiceForDisplay={
                                    setCurrentSelectedServiceForDisplay
                                }
                                setProvider={setProvider}
                                provider={provider}
                                currentSelectedServiceForDisplay={currentSelectedServiceForDisplay}
                                otherLocationsOpen={otherLocationsOpen}
                                setOtherLocationsOpen={setOtherLocationsOpen}
                                topLocation={topLocation}
                                setTopLocation={setTopLocation}
                                loading={loading}
                                setLoading={setLoading}
                            />
                        );
                    }}
                />
                <Route
                    path={ERROR_ROUTE}
                    exact
                    render={() => {
                        if (!haveMemberDetails()) {
                            return <Redirect to={LOGIN_ROUTE} />;
                        }
                        return <FallbackPage />;
                    }}
                />
            </Switch>
        );
    }

    return props.embedded ? (
        <MemoryRouter data-testid="memRouter">{getSwitch()}</MemoryRouter>
    ) : (
        <HashRouter data-testid="hashRouter">{getSwitch()}</HashRouter>
    );
}
